import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import State from '@wfp-root-app/store/state';

import { ActionCreators as ManagerActionCreators } from '../managers/managers';
import { ActionCreators as AuthActionCreators } from '../login/auth';
import ManagerDisableOtpConfirmationDialog from '../managers/ManagerDisableOtpConfirmationDialog';

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

interface SecurityPageState {
    isResetOtpConfirmVisible: boolean;
    isChangePasswordConfirmVisible: boolean;
}

class SecurityPage extends React.Component<Props, SecurityPageState> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isResetOtpConfirmVisible: false,
            isChangePasswordConfirmVisible: false,
        };
    }

    onResetOtp = async (): Promise<void> => {
        if (this.props.auth?.manager) {
            await this.props.resetOtpRequest(this.props.auth.manager);
        }
    };

    onConfirmResetOtp = async (): Promise<void> => {
        this.setState({ isResetOtpConfirmVisible: false });
        await this.onResetOtp();
    };

    onConfirmChangePassword = async (): Promise<void> => {
        this.setState({ isChangePasswordConfirmVisible: false });
        await this.props.requestPasswordReset();
    };

    render() {
        return (
            <main>
                {this.state.isResetOtpConfirmVisible && (
                    <ManagerDisableOtpConfirmationDialog
                        confirmTitle="Yes"
                        description={'Are you sure you want to reset your one time password?'}
                        onClose={() => this.setState({ isResetOtpConfirmVisible: false })}
                        onSubmit={this.onConfirmResetOtp}
                        title="Reset One Time Password"
                    />
                )}
                {this.state.isChangePasswordConfirmVisible && (
                    <ManagerDisableOtpConfirmationDialog
                        confirmTitle="Yes"
                        description={'Are you sure you want to reset your password?'}
                        onClose={() => this.setState({ isChangePasswordConfirmVisible: false })}
                        onSubmit={this.onConfirmChangePassword}
                        title="Reset Password"
                    />
                )}
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <button
                                className="wfp-btn"
                                onClick={() => this.setState({ isChangePasswordConfirmVisible: true })}
                                type="button"
                            >
                                Reset Password
                            </button>
                        </div>
                    </div>
                    <div className="row" style={{ marginTop: 16 }}>
                        <div className="col-md-6">
                            <button
                                className="wfp-btn"
                                onClick={() => this.setState({ isResetOtpConfirmVisible: true })}
                                type="button"
                            >
                                Reset OTP
                            </button>
                        </div>
                    </div>
                </div>
            </main>
        );
    }
}

function mapStateToProps(state: State) {
    return {
        auth: state.auth,
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mapDispatchToProps(dispatch: any) {
    return {
        resetOtpRequest: bindActionCreators(ManagerActionCreators.resetOtpRequest, dispatch),
        requestPasswordReset: bindActionCreators(AuthActionCreators.requestPasswordReset, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SecurityPage);
